export const COPILOT_CONVERSATION_CREATED_EVENT =
  "ui2026:copilot-conversation-created";
export const COPILOT_CONVERSATION_VIEWED_EVENT =
  "ui2026:copilot-conversation-viewed";
/** Fired after a sidebar rename; detail is ``{ id, title }``. */
export const COPILOT_CONVERSATION_RENAMED_EVENT =
  "ui2026:copilot-conversation-renamed";

export interface CopilotConversationRenamedDetail {
  id: number;
  title: string;
}

/** Fired after a flag is marked reviewed outside the Predict list (e.g. from
 *  a flag chat), so flag lists refresh; detail is ``{ alertId }``. */
export const FLAG_REVIEWED_EVENT = "ui2026:flag-reviewed";
